/**
 * Loading Actions
 */
import { SET_LOADING, SET_GET_LOADING, SET_COMMON_POPUP, CLOSE_COMMON_POPUP, SET_COMMON_DIALOG, CLOSE_COMMON_DIALOG } from 'Actions/types';

export const setLoading = data => ({
  type: SET_LOADING,
  payload: data,
});

export const setGetLoading = data => ({
  type: SET_GET_LOADING,
  payload: data,
});

export const setCommonPopup = data => ({
  type: SET_COMMON_POPUP,
  payload: { show: true, ...data },
});

export const closeCommonPopup = () => ({
  type: CLOSE_COMMON_POPUP,
});

export const setCommonDialog = data => ({
  type: SET_COMMON_DIALOG,
  payload: { show: true, ...data },
});

export const closeCommonDialog = () => ({
  type: CLOSE_COMMON_DIALOG,
});
